<div class="ar-shell">
  <div class="ar-header">
    <div class="ar-icon">
      <mat-icon>{{ isAssign ? 'autorenew' : 'event_busy' }}</mat-icon>
    </div>
    <div class="ar-header-text">
      <div class="ar-title" *ngIf="isAssign">
        Asignar el patrón <span class="ar-rotation-name">{{ data.rotationName }}</span>
      </div>
      <div class="ar-title" *ngIf="!isAssign">
        Terminar el patrón <span class="ar-rotation-name">{{ data.rotationName }}</span>
      </div>
      <div class="ar-subtitle" *ngIf="isAssign">
        Ciclo de {{ cycleLength }} días contados desde la fecha de inicio.
      </div>
      <div class="ar-subtitle" *ngIf="!isAssign">
        Desde la fecha elegida los días dejan de seguir el patrón; quedan sin turno salvo los ajustes individuales.
      </div>
    </div>
  </div>

  <div class="ar-day-strip" *ngIf="isAssign && data.days?.length">
    <span
      class="ar-day-chip"
      *ngFor="let day of data.days"
      [style.background]="chipBackground(day.color)"
      [style.color]="day.color"
    >
      {{ day.letter }}
    </span>
  </div>

  <label class="ar-field">
    <span class="ar-field-label">{{ isAssign ? 'Inicio del ciclo' : 'Terminar desde' }}</span>
    <input
      type="date"
      class="ar-date-input"
      [class.ar-date-input--invalid]="!isStartDateValid"
      [(ngModel)]="startDate"
      [attr.min]="data.minDate"
    />
  </label>
  <div class="ar-hint ar-hint--warn" *ngIf="!isStartDateValid">
    Elige una fecha{{ data.minDate ? ' a partir del ' + data.minDate : '' }}.
  </div>
  <div class="ar-hint" *ngIf="startWeekdayNote">{{ startWeekdayNote }}</div>

  <div class="ar-repeat" *ngIf="isAssign">
    <div class="ar-repeat-row">
      <div class="ar-repeat-text">
        <span class="ar-repeat-title">Repetir indefinidamente</span>
        <span class="ar-repeat-sub">
          {{ repeatForever
            ? 'Sin límite de tiempo: el ciclo sigue hasta que lo termines.'
            : 'El patrón tiene fecha fin: se repite hasta el ' + endDateLabel + '.' }}
          Se define en la configuración del patrón.
        </span>
      </div>
      <mat-slide-toggle [checked]="repeatForever" disabled></mat-slide-toggle>
    </div>
  </div>

  <div class="ar-actions">
    <button type="button" class="ar-btn-cancel" (click)="cancel()">Cancelar</button>
    <button type="button" class="ar-btn-apply" [disabled]="!isStartDateValid" (click)="apply()">
      {{ isAssign ? 'Aplicar' : 'Terminar patrón' }}
    </button>
  </div>
</div>
